import { useState } from "react";
import { ResourceManager } from "@/components/ResourceManager";
import { Button } from "@/components/ui/button";
import { HandCoins, FileDown, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const fields = [
  { name: "donor_name", label: "Donor Name", type: "text", required: true },
  { name: "amount", label: "Amount (INR)", type: "number" },
  { name: "category", label: "Category", type: "select", options: ["General", "Gau Seva", "Annadan", "Education", "Health", "Yoga & Wellness", "Environment"] },
  { name: "mode", label: "Mode", type: "select", options: ["Cash", "UPI", "Cheque", "Bank Transfer", "Online"] },
  { name: "date", label: "Date", type: "date" },
  { name: "reference", label: "Reference / Txn ID", type: "text", table: false },
  { name: "notes", label: "Notes", type: "textarea", table: false },
];

function ReceiptButton({ item }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/admin/donations/${item.id}/receipt`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = `Receipt-${item.receipt_no || item.id}.pdf`;
      a.click();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch {
      toast.error("Could not generate receipt");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button size="icon" variant="ghost" title="Download receipt (PDF)" onClick={download} disabled={busy} data-testid={`donation-receipt-${item.id}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4 text-[#B38728]" />}
    </Button>
  );
}

export default function DonationsAdmin() {
  return (
    <ResourceManager title="Donation Records" eyebrow="Finance" endpoint="donations" fields={fields} icon={HandCoins}
      idField="receipt_no" rowActions={(item) => <ReceiptButton item={item} />} />
  );
}
